<template>
    <div class="item-box boxShadow  flexColumn">
        <div style="width: 100%;">
            <div v-for="item in currentPageData" 
               :key="item.id" class="flexBetween itemsCenter" >
                <div class="flex item-box-items itemsCenter flexNowarp ">
                    <p>{{ item.name }}</p> 
                    <div class="flex ">
                        <div  v-for="(item) in item.subChildren"
                          class="item-box-items-labels "
                          @click="gotoJob(item.code)" :key="item.id">
                          {{ item.name }}
                        </div>
                    </div>
                </div>
                <i class="el-icon-caret-right shrink"></i>
                <div class="item-box-more">
                    <p class="item-box-more-title">{{ item.name }}</p>
                    <div v-for="item in item.children" class="flex" style="margin: 10px 0 20px;"  :key="item.id">
                        <p class="item-box-more-subtitle">{{ item.name }}</p>
                        <ul class="item-box-more-titleitem flex ">
                            <li v-for="items in item.children" :key="items.id"  @click="gotoJob(items.code)">{{ items.name }}</li>
                        </ul>
                    </div>
                </div>
        
            </div>
        </div>

        <div class=" item-box-input flexCentet itemsCenter">
            <div class="item-box-input-opeart" @click="prev"><i class="el-icon-arrow-left"></i></div>
            <el-input v-model="currentPage" placeholder="1" @change="pageChange"  size="mini"></el-input>
            <div class="item-box-input-opeart">/</div>  
            <div>{{ pageAll }}</div>
            <div class="item-box-input-opeart" @click="next"><i class="el-icon-arrow-right"></i></div>
        </div>
        
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  export default {
    props: {},
    data() {
      return {
       
        pageSize:7,   //每页显示几条数据
        currentPage:1,//当前第几页
        // pageAll:1,    //一共有几页
        // currentPageData:[], //当前页显示的数据
        showMoreBox:false,
      };
    },
    created(){
        this.dealPage();
        this.getCurrentPageData();
    },
    computed: {
      ...mapState({
        allJob:state => state.jobs.allJob,
      }),
      total:{
        get(){
            return this.allJob.length
        },
        set(){}
      },
      pageAll:{
        get(){
           this.totalPage=Math.ceil(this.allJob.length / this.pageSize);
           return  this.totalPage
        },
        set(){}
      },
      currentPageData:{
        get(){
            let first = (this.currentPage-1) * this.pageSize;
            let end = this.currentPage * this.pageSize;
            return this.allJob.slice(first,end);
        },
        set(){}
      }
    },
    methods: {
        pageChange(){
            console.log(this.value,121333)
        },
        prev(){
            if(this.currentPage==1){
               return;
            }else{
                this.currentPage -- ;
                this.getCurrentPageData();
            }
        },
        next(){
            if(this.currentPage== this.pageAll){
               return;
            }else{
                this.currentPage++;
                this.getCurrentPageData();
            }
        },
        gotoJob(value){
            this.$router.push({
                path:`/job`,
                query:{
                    positionKind:value
                }
            })
        },

        dealPage(){
            this.total = this.allJob.length;
            this.pageAll =Math.ceil(this.total / this.pageSize) 
        },
        getCurrentPageData(){
            let first = (this.currentPage-1) * this.pageSize;
            let end = this.currentPage * this.pageSize;
            this.currentPageData = this.allJob.slice(first,end);
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
    $mianColor:#287CF3;
    .item-box {
        justify-content: space-between;
        box-sizing:border-box;
        border: 1px solid #E2E3EB;
        background-color: $whiteColor;
        width: 382px;
        padding: 10px 8px;
        color: $fontCol;
        position: relative;
        height: 392px;
        .flexBetween{
            transition: all .2s linear;
            padding: 0 16px;
            cursor: pointer;
            &:hover{
                box-shadow: 0 4px 16px 0 rgba(153,153,153,.2);
                border-radius: 6px;
                .el-icon-caret-right{
                    color: $mianColor !important;
                }
                &::before{
                    content: ' ';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: -4px;
                    width: 12px;
                    z-index: 1;
                }
                .item-box-more{
                    display: block;
                }
            }
        }
        &-items{
            padding: 12px 0;
            width: 90%;
            overflow: hidden;
            
            p{
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                padding-right: 20px;
                flex-shrink: 0;
            }
            div{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                flex-shrink: 0;
                cursor: pointer;
                &:not(:last-child){
                    margin-right: 20px;
                }
            }
            &-labels{
                &:hover{
                    color: $mianColor;
                    font-weight: 500;
                }
            }
        }
        &-input{
            .el-input{
                width: 50px;
            }
            &-opeart{
                padding: 10px;
                cursor: pointer;
            }
        }
        .el-icon-caret-right{
            color: #ccc !important;
        }
        .el-icon-arrow-left,.el-icon-arrow-right{
            font-size: 16px;
            color: rgba(0,0,0,0.88) !important;
        }
        &-more{
            box-sizing:border-box;
            position: absolute;
            left: 384px;
            top: 0;
            height: 100%;
            width: 896px;
            padding: 16px 8px 10px 16px;
            margin-top: 0;
            overflow: overlay;
            overflow: auto;
            z-index: 1;
            background: #fff;
            box-shadow: 0 10px 40px 0 rgba(153,153,153,.2);
            border-radius: 6px;
            border: 1px solid #ebeef5;
            display: none;
            z-index: 1;
            &-title{
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                padding-right: 20px;
                flex-shrink: 0;
                padding-top: 20px;
            }
            &-subtitle{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                flex-shrink: 0;
                width: 100px;
                
            }
            &-titleitem{
               border-bottom: 1px solid #f0f3fa;
               width: 100%;
               flex-wrap: wrap;
               li{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                padding-bottom: 10px;
                padding-right: 20px;
                cursor: pointer;
                &:hover{
                    color: $mianColor;
                    font-weight: 500;
                }
               }
            }
            // transition: all .2s linear;
        }
        
    }
  </style>
  